import React, { useState, useEffect } from 'react';
import {
  Container,
  Col,
  Row,
  Card,
  CardBody,
  Label,
  CustomInput,
  FormGroup,
  Button,
  Spinner,
} from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import Select from 'react-select';
import { useHistory } from 'react-router-dom';
import useGet from '../../helpers/hooks/useGet';
import usePatch from '../../helpers/hooks/usePatch';
import useAttachement from '../../helpers/hooks/useAttachments';
import toastr from 'toastr';
import _ from 'lodash';
const AdvisorDetails = ({
  match: {
    params: { id },
  },
}) => {
  const history = useHistory();
  const [advisor, , advisorLoading] = useGet(`/advisories/${id}`, true);
  const [districts, , districtsLoading] = useGet('/districts', true);
  const [languages, , languagesLoading] = useGet('/languages', true);
  const [expertise, , expertiseLoading] = useGet('/advisory-expertises', true);
  const [vegetables, , vegetablesLoading] = useGet('/vegetables', true);
  const [postAdvisory, postedData, postingError, dataPosting] = usePatch(
    `/advisories/${id}`
  );
  const { upload, error, loading: imagesUploading, urls } = useAttachement();
  const [selectedDistricts, setSelectedDistricts] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [selectedExpertise, setSelectedExpertise] = useState([]);
  const [selectedVegetables, setSelectedVegetables] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const handleFormSubmit = (event, errors, values) => {
    console.log( "he;;o",
      selectedDistricts,
      selectedLanguages,
      selectedExpertise,
      selectedVegetables
    );
    if (errors.length > 0) {
      return toastr.warning('Please fix errors in the form');
    }
    if (
      !selectedDistricts ||
      !selectedLanguages ||
      !selectedExpertise ||
      !selectedVegetables
    ) {
      return toastr.warning('Please fix errors in the form');
    }
    if (
      selectedDistricts.length === 0 ||
      selectedLanguages.length === 0 ||
      selectedExpertise.length === 0 ||
      selectedVegetables.length === 0
    ) {
      return toastr.warning('Please fix errors in the form');
    }
    const obj = _.omit(
      {
        ...values,
        languageIds: selectedLanguages.map((x) => x.value),
        expertiseIds: selectedExpertise.map((x) => x.value),
        districtIds: selectedDistricts.map((x) => x.value),
        vegetableIds: selectedVegetables.map((x) => x.value),
      },
      values.password.length === 0 && 'password'
    );
    if (selectedImage) {
      upload([selectedImage]).then((_urls) => {
        postAdvisory({ ...obj, image: _urls[0] });
      });
    } else {
      postAdvisory(obj);
    }
  };
  useEffect(() => {
    if (advisor) {
      setSelectedDistricts(
        advisor.districts?.map((x) => ({ value: x.id, label: x.name }))
      );
      setSelectedLanguages(
        advisor.languages?.map((x) => ({ value: x.id, label: x.name }))
      );
      setSelectedVegetables(
        advisor.vegetables?.map((x) => ({ value: x.id, label: x.name }))
      );
      setSelectedExpertise(
        advisor.expertises?.map((x) => ({ value: x.id, label: x.name }))
      );
    }
  }, [advisor]);
  useEffect(() => {
    if (postingError) {
      console.log(postingError);
      toastr.error(postingError.error.message);
    }
  }, [postingError]);
  useEffect(() => {
    if (postedData) {
      toastr.success('Advisor has been updated successfully');
      history.push('/users/advisors');
    }
  }, [history, postedData]);
  return (
    <>
      <div className='page-content'>
        <Container fluid>
          <AvForm className='needs-validation' onSubmit={handleFormSubmit}>
            <Row>
              <Col md={{ size: 8, offset: 2 }}>
                <h4>Edit Advisor</h4>
                <Card>
                  <CardBody>
                    {advisorLoading ? (
                      <div className='text-center'>
                        <Spinner className='mr-2' color='primary' />
                      </div>
                    ) : (
                      <>
                        <FormGroup>
                          <Label htmlFor='name'>Name</Label>
                          <AvField
                            name='name'
                            placeholder='Name'
                            type='text'
                            errorMessage='Enter Name'
                            className='form-control'
                            validate={{ required: { value: true } }}
                            id='name'
                            value={advisor?.name}
                          />
                        </FormGroup>
                        <Row className='mb-3'>
                          <Col md={1}>
                            <img
                              src={advisor?.image}
                              className='rounded-circle avatar-sm card-img'
                            />
                          </Col>
                          <Col md={11}>
                            {' '}
                            <FormGroup>
                              <div className='custom-file'>
                                <CustomInput
                                  type='file'
                                  className='custom-file-input'
                                  id='image'
                                  accept='image/*'
                                  onChange={(e) => {
                                    setSelectedImage(e.target.files[0]);
                                  }}
                                />
                                <Label
                                  className='custom-file-label'
                                  htmlFor='image'
                                >
                                  {selectedImage
                                    ? selectedImage.name
                                    : 'Change Profile Picture'}
                                </Label>
                              </div>
                              {selectedImage && (
                                <span className='d-block font-size-20 text-danger text-right'>
                                  <i
                                    onClick={() => setSelectedImage(null)}
                                    style={{ cursor: 'pointer' }}
                                    className='ri-close-line'
                                  ></i>
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>

                        <FormGroup>
                          <Label htmlFor='phone'>Phone</Label>
                          <AvField
                            name='phone'
                            placeholder='Phone (923xxxxxxxxxx)'
                            type='text'
                            errorMessage='Enter Phone in (923xxxxxxxxxx)'
                            className='form-control'
                            validate={{
                              required: { value: true },
                              pattern: { value: '^923' },
                              minLength: { value: 12 },
                              maxLength: { value: 12 },
                            }}
                            id='name'
                            value={advisor?.phone}
                          />
                        </FormGroup>

                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <Label>Districts</Label>
                              <Select
                                isLoading={districtsLoading}
                                value={selectedDistricts}
                                isMulti
                                closeMenuOnSelect={false}
                                onChange={(e) => setSelectedDistricts(e)}
                                options={
                                  districts &&
                                  districts.map((x) => ({
                                    value: x.id,
                                    label: x.name,
                                  }))
                                }
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <Label>Languages</Label>
                              <Select
                                isLoading={languagesLoading}
                                value={selectedLanguages}
                                isMulti
                                closeMenuOnSelect={false}
                                onChange={(e) => setSelectedLanguages(e)}
                                options={
                                  languages &&
                                  languages.map((x) => ({
                                    value: x.id,
                                    label: x.title,
                                  }))
                                }
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <Label>Crops</Label>
                              <Select
                                isLoading={vegetablesLoading}
                                value={selectedVegetables}
                                isMulti
                                closeMenuOnSelect={false}
                                onChange={(e) => setSelectedVegetables(e)}
                                options={
                                  vegetables &&
                                  vegetables.map((x) => ({
                                    value: x.id,
                                    label: x.name,
                                  }))
                                }
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <Label>Problems Expertise</Label>
                              <Select
                                isLoading={expertiseLoading}
                                value={selectedExpertise}
                                isMulti
                                closeMenuOnSelect={false}
                                onChange={(e) => setSelectedExpertise(e)}
                                options={
                                  expertise &&
                                  expertise.map((x) => ({
                                    value: x.id,
                                    label: x.name,
                                  }))
                                }
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <div className='border mb-3 mt-2'></div>
                        <FormGroup>
                          <Label htmlFor='password'>Change Password</Label>
                          <AvField
                            name='password'
                            placeholder='Password'
                            type='text'
                            errorMessage='Minimun length required is 5'
                            className='form-control'
                            validate={{
                              minLength: { value: 5 },
                            }}
                            id='password'
                          />
                        </FormGroup>
                      </>
                    )}
                  </CardBody>
                </Card>
                <div className='text-right mb-5'>
                  <Button
                    color='primary'
                    disabled={dataPosting || imagesUploading}
                  >
                    {dataPosting || imagesUploading
                      ? 'Saving...'
                      : 'Update Advisor'}
                  </Button>
                </div>
              </Col>
            </Row>
          </AvForm>
        </Container>
      </div>
    </>
  );
};

export default AdvisorDetails;
